import CompanyEdit from '@/components/company/edit/CompanyEdit.vue'
import DepartmentList from '@/components/company/departments/list/DepartmentList.vue'
const defaultFilterValues = {
  code: '',
  name: '',
  company: ''
};

export default {
  name: 'ScheduleSettings',
  components: {
    CompanyEdit,
    DepartmentList
  },
  data () {
    return {
      loading: true,
      currentReq: null,
      originalTableItems: [],
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'code', direction: 'asc' },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false,
      userType: {},
      defaultSymbolValue: 'h',
      defaultHoursCalculationMonth: 'current',
      clearingCache: false
    };
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'company_id', label: this.$t('company-structure.company.name'), format: 'formatFromConfig', configKey: 'user_companies', configParam: 'name', filterKey: 'company' },
        { key: 'name', label: this.$t('company-structure.department.name'), sortable: false, filterKey: 'name' },
        { key: 'code', label: this.$t('general.item.code'), sortable: true, filterKey: 'code' },
        { key: 'head_user.fullname', label: this.$t('work-schedule.settings.record-symbol'), type: 'slot', slotcode: 'options' },
        { key: 'hours_calculation', label: this.$t('work-schedule.settings.hours-calculation'), type: 'slot', slotcode: 'hours_calculation' }
      ];
      return headers;
    },
    tableExpandConfig () {
      return { component: 'slot' }
    },
    tableFilterConfig () {
      const filters = { };
      filters.company = { type: 'select', label: '', options: this.companyOptions, colOnlyFilter: true };
      filters.code = { type: 'text', label: '', colOnlyFilter: true };
      filters.name = { type: 'text', label: '', colOnlyFilter: true };
      filters.disabled = { type: 'checkbox', label: '', options: this.yesNoOptions, colOnlyFilter: true };
      return filters;
    },
    canEnableDisable () {
      return this.ApiRequest.userHasPermission('edit-company-settings');
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-company-settings');
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions(true);
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath('ezuro/schedule/settings/?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filterValues, true);
      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }
      return path;
    },
    tableActions () {
      const actions = { };
      if (this.canEdit) {
        // Not implemented API company add
        // actions.add = { title: this.$t('menu.companies.company.new') };
      }
      return actions;
    },
    symbols () {
      return [{ value: 'h', text: 'h', code: 'h' }, { value: 'd', text: 'd', code: 'd' }];
    },
    hoursCalculationOptions () {
      return [
        { value: 'current', text: this.$t('work-schedule.settings.hours-calculation-current') },
        { value: 'next', text: this.$t('work-schedule.settings.hours-calculation-next') }
      ];
    },
    companyOptions () {
      return this.BasicHelper.sortArrayByKeyValue(this.$store.getters.getConfigOptions('user_companies', this.$i18n.locale, 'disabled', '0'), 'text');
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.loading = true;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          this.tableItems = response.data;
          this.originalTableItems = this.BasicHelper.cloneObject(response.data);
          this.paging = response.paging;
          this.loading = false;
        }
      });
    },
    saveSettings () {
      this.loading = true;
      const settingsToCheck = ['row_entry_symbol', 'hours_calculation_month'];
      const changedRows = this.tableItems.filter((row, index) => {
        return settingsToCheck.some(setting =>
          row.ez_settings[setting] !== this.originalTableItems[index].ez_settings[setting]
        );
      });

      this.ApiRequest.request('ezuro/schedule/settings/', this.ApiRequest.REQUEST_POST, { settings: changedRows }, (response) => {
        if (response.data) {
          this.originalTableItems = this.BasicHelper.cloneObject(this.tableItems);
          this.$store.commit('toastAdd', { context: 'success', message: this.$t('work-schedule.settings.saved') });
        }
        this.loading = false;
      });
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    itemUpdated () {
      this.$emit('saved');
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.paging.page = 1;
        this.getTableData();
      }
    },
    clearCache () {
      this.clearingCache = true;
      this.ApiRequest.request('admin/clear-cache', this.ApiRequest.REQUEST_GET, [], () => {
        this.clearingCache = false;
      })
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.getTableData();
    this.isMounted = true;
  }
}
